import React from 'react';
import { useNavigate } from 'react-router-dom';
import './style/Cancel.css';
import { FaTimesCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Cancel = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="cancel-page">
      <div className="cancel-box">
        <FaTimesCircle className="cancel-icon" />
        <h2>{t('CancelSubscription.title')}</h2>
        <p>{t('CancelSubscription.message')}</p>
        <button onClick={() => navigate('/pricing')}>{t('CancelSubscription.Retry')}</button>
      </div>
    </div>
  );
};

export default Cancel;
